module.exports = __webpack_public_path__ + "images/mobile/img-empty-stars-18c025d79b85514dc03deda8835c061c.png";